export type PaginatedResult<T> = {
  items: T[];
  total: number;
};

export const isPaginatedResult = <T>(value: unknown): value is PaginatedResult<T> => {
  return typeof value === 'object' && value !== null && 'items' in value && 'total' in value;
};

export type PaginationMetadata = {
  page: number;
  pageSize: number;
  total: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPrevPage: boolean;
};
